<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title v-text="$t('keywords.register')" />
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.credentialName)"
                  name="credentialName"
                  :label="$t('credentials.name')"
                  :hint="$t('credentials.name_hint')"
                  v-model="objEditar.credentialName"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  :readonly="isUpdating"
                  :items="types"
                  item-text="label"
                  item-value="value"
                  :label="$t('credentials.type')"
                  v-model="objEditar.type"
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :rules="requiredRules(objEditar.username)"
                  name="username"
                  :label="$t('keywords.username')"
                  v-model="objEditar.username"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  name="password"
                  :label="$t('keywords.password')"
                  type="password"
                  v-model="objEditar.password"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/CredentialsService'
import LocalStorageService from '../../services/LocalStorageService'
import { alphaNumericRules, requiredRules } from '../../utils/rules'

export default {
  name: 'credentialForm',

  props: {
    identifier: String
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    objEditar: {
      credentialName: '',
      username: '',
      password: '',
      type: '',
      clientPrefix: ''
    },
    showPwd: false,
    isUpdating: false
  }),

  computed: {
    types () {
      return [
        { label: this.$t('credentials.share'), value: 'SHARE' },
        { label: this.$t('keywords.db'), value: 'DATABASE' },
        { label: this.$t('credentials.ws.authentication'), value: 'AUTHENTICATION_WS' },
        { label: this.$t('credentials.ws.authorization'), value: 'AUTHORIZATION_WS' },
        { label: this.$t('credentials.mail'), value: 'EMAIL' },
        { label: 'FTP', value: 'FTP' }
      ]
    }
  },

  mounted () {
    this.loadDB()
  },

  methods: {
    loadDB () {
      if (this.identifier) {
        Servico.findById(this.identifier)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()
      if (this.$refs.form.validate()) {
        if (this.isUpdating) {
          this.updateItem()
        } else {
          this.createItem()
        }
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(response => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(response => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }
}
</script>
